var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeroImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 38.4C20.1809 38.4 16.5182 36.8829 13.8177 34.1823C11.1172 31.4818 9.60002 27.8191 9.60002 24C9.60002 20.1809 11.1172 16.5182 13.8177 13.8177C16.5182 11.1171 20.1809 9.60001 24 9.60001L24 24L24 38.4Z",
    fill: "#0048D3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4 24C38.4 25.891 38.0276 27.7636 37.3039 29.5106C36.5802 31.2577 35.5195 32.8452 34.1824 34.1823C32.8452 35.5195 31.2578 36.5802 29.5107 37.3039C27.7636 38.0275 25.8911 38.4 24 38.4L24 24L38.4 24Z",
    fill: "#FBC813"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroImg);
export default __webpack_public_path__ + "static/media/heroImg.a1be131c4e04ec5c4dfa59e5b7fd13cb.svg";
export { ForwardRef as ReactComponent };